export const INITIAL_ALERTS_STATE = {
  showFormError: false,
  showInvalidCnpj: false,
  showInvalidEmail: false,
};
